<!-- 检测数据 录入/修改 sqm -->
<template>
  <ComponentDetectData :kindType="data.kindType" :getData="data.getData" :tableLoading = "data.tableLoading" v-if="data.getData.supplyCode" @submitBtn="submit" @backBtn="routerBack"
    :subLoading="data.subLoading" v-loading="data.pageLoading" @getInfoBtn="getInfo"></ComponentDetectData>
    <div v-else style="width:100%; height: 600px;" v-loading="data.pageLoading"></div>
</template>


<script setup>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';

  import { reactive, getCurrentInstance, onMounted, onUpdated, nextTick, onBeforeMount, onActivated, onDeactivated } from "vue";
  import { onBeforeRouteLeave, useRoute } from "vue-router";
  import axios from "axios";
  import ComponentDetectData from "../ComponentDetectData"
  const { proxy, ctx } = getCurrentInstance()
  const route = useRoute()

  const data = reactive({
    kindType:'sqmModify',
    getData:{},
    subLoading:false,
    tableLoading: false,
    newUuid:'',
    pageLoading:false,
  })
  const routerBack = () => {
    proxy.$router.back()
  }
  const getInfo = () => {
    data.tableLoading = true
    data.pageLoading = true
    proxy.$http({
     url:'/base/newrohs/queryCheckDateList',
     method:'post',
      data:{
        fixConfig:true,
        uuid:data.uuid || data.newUuid
      }
    }).then((res=>{
      data.getData.dataOfTable = res.data.data
    })).catch(err=>{

    }).finally(()=>{
      data.getData.supplyCode = route.query.supplyCode ?  route.query.supplyCode : ''
      data.getData.supplyName = route.query.supplyName ?  route.query.supplyName : ''
      data.tableLoading = false
      data.pageLoading = false
      for(let i = 1 ; i < 10; i++){
      setTimeout(() => {
          proxy.postThisPageHeightMore()
        }, i*100);
      }
    })
  }
  const submit = (val) => {
    data.pageLoading = true
    data.subLoading = true
    let postVal = val.dataOfTable.map(item=>{
      delete item.indexId
      return item
    })
    proxy.$http({
      url:'/base/newrohs/addCheckDateListN',
      method:'post',
      data:{
        uuid:data.newUuid || data.uuid,
        list:[...postVal],
        fixConfig:true,
        userName:data.trueName,
      }
    }).then((res=>{
      if(res.data > 0){
        proxy.success({
          message: h_i18n('ddf4ad479c4d75ac1b28639e2a26f5f8'),
          title: h_i18n('330363dfc524cff2488f2ebde0500896'),
          confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
          cancelButtonText:h_i18n('625fb26b4b3340f7872b411f401e754c'),
          callback: (action) => {
            if(action == 'confirm'){
              routerBack()
            }else{

            }
          }
        });
        data.uuid = data.uuid ? data.uuid : data.newUuid
        getInfo()
      }else{
        proxy.info(h_i18n('6de920b4e4e08b261cda928d9beefab4'))
      }
    })).catch(err=>{

    }).finally(()=>{
      data.pageLoading = false
      data.subLoading = false
    })
  }

  onBeforeMount(()=>{
    if (route.query) {
      data.supplyCode = route.query.supplyCode ?  route.query.supplyCode : ''
      data.supplyName = route.query.supplyName ?  route.query.supplyName : ''
      data.kindType = route.query.kindType ? route.query.kindType : 'sqmModify'
      data.userName = route.query.userName ?  route.query.userName : ''
      data.trueName = route.query.trueName ?  route.query.trueName : ''
      data.getData.userName = route.query.userName ?  route.query.userName : ''
      data.getData.trueName = route.query.trueName ?  route.query.trueName : ''
      if(route.query.kindType == 'sqmAdd'){
        data.newUuid = route.query.uuid ?  route.query.uuid : ''
      }else{
        data.uuid = route.query.uuid ?  route.query.uuid : ''
      }
    }    
  })
  onMounted(() => {
    if(route.query.dataFrom != 'sqm'){
      proxy.$router.replace('/404')
      return
    }
    if(!route.query.supplyCode){
      proxy.info({title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'), message: h_i18n('c0f92e28b64a4268408f10aa60dc47c8'),confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
        callback: (action) => {
          routerBack()
        },})
      return
    }
    getInfo()
    // for(let i = 1 ; i < 10; i++){
    //   setTimeout(() => {
    //     proxy.postThisPageHeightMore()
    //   }, i*100);
    // }
  })
</script>

<style>

</style>